// @flow

export default (url:string):string =>
  url.split('?')[0]
    .toLowerCase()
    .replace(/\/\d+/g, '')
    .replace(/:\d+/g, '')
    .replace(/\.com|\.co/, '')
    .replace(/www\./, '')
    .replace(/https?:\/\//, '')
    .replace(/[\/|.]/g, '-')
    .replace(/^-|-$/g, '');



/** WEBPACK FOOTER **
 ** ./app/wip_modules/metrics/urlToKey.js
 **/